import Layout from '@/features/reservation/components/Layout';
import React from 'react';
import { MEDICAL_CARE_TITLE, NURSING_CARE_TITLE } from '../constants/PreData';
import { Box, Button, Link, Paper, Typography } from '@mui/material';
import { eAgreeState, eFacilityState, facilityType } from '../type/contract';

type TermsAgreementProps = {
  nextTrans: () => void;
  facilityType: facilityType;
  facilityName: string | '';
  medicalTreatment: string | '';
  fileName: string | '';
  filePath: string | '';
  explanationTitle: string | '';
  explanation: string | '';
  contractJudgeTerms: eAgreeState;
  setContractJudgeTerms: (state: number) => void;
};

// 病院包括規約同意
export const TermsAgreement = (props: TermsAgreementProps) => {
  // 同意選択時の処理
  const AgreementHandler = () => {
    props.setContractJudgeTerms(eAgreeState.agree);
    props.nextTrans();
  };

  // すでに同意済みなら表示しない
  if (props.contractJudgeTerms === eAgreeState.agree) {
    props.nextTrans();
  }

  return (
    <Layout title={props.facilityName}>
      <Box sx={{ margin: 'auto', px: 3, pt: 6 }}>
        <Typography className="text-lg text-center font-bold">
          {props.facilityType === eFacilityState.medicalCare ? MEDICAL_CARE_TITLE : NURSING_CARE_TITLE}
        </Typography>
        <Typography className="text-sm pt-6 text-left">
          下記の診療行為に関して、ご理解の上包括的に同意をしていただきますようお願いいたします。
        </Typography>
      </Box>
      <Box sx={{ margin: 'auto', px: 3, py: 1 }}>
        <Paper elevation={0} className="p-3 max-h-60 overflow-y-auto">
          {/* 診療行為文章 */}
          <Typography className="text-sm text-left leading-normal word-wrap whitespace-pre-wrap">
            {/* 改行\nを正しく改行 */}
            {props.medicalTreatment.split('\\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </Typography>
        </Paper>
      </Box>
      <Box sx={{ margin: 'auto', px: 3, py: 1 }}>
        <Typography className="text-left text-lg text-red-600 font-semibold">{props.explanationTitle}</Typography>
        <Typography className="text-left text-sm text-red-600 py-2 leading-normal">
          {/* 改行\nを正しく改行 */}
          {props.explanation.split('\\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </Typography>
      </Box>
      <Box sx={{ margin: 'auto', px: 3 }}>
        <Link href={props.filePath} download={props.fileName} target={'_blank'} rel={'noopener noreferrer'}>
          <Typography className="py-3 text-sm text-right text-current">ダウンロード（PDF）</Typography>
        </Link>
        <Button className="w-full h-auto py-3 bg-primary text-white text-lg font-semibold" onClick={AgreementHandler}>
          同意して次へ進む
        </Button>
        <Typography className="py-3 text-sm text-center text-primary">
          同意しない場合は、
          <wbr />
          {props.facilityName} <wbr />
          にお問い合わせください。
        </Typography>
      </Box>
    </Layout>
  );
};

export default TermsAgreement;
